import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
@Pipe({
  name: 'stripHtml'
})
export class StripHtmlPipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    if (!value) return '';
    return value.replace(/<[^>]*>/g, '');
  }

}
